import { render, staticRenderFns } from "./shareInfoItemDetail.vue?vue&type=template&id=1a7af503&scoped=true"
import script from "./shareInfoItemDetail.vue?vue&type=script&lang=js"
export * from "./shareInfoItemDetail.vue?vue&type=script&lang=js"
import style0 from "../../assets/css/articleDetail.css?vue&type=style&index=0&id=1a7af503&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a7af503",
  null
  
)

export default component.exports